const ACTIONS = {
  CALL_API: 'call-api',
  SUCCESS: 'success',
  ERROR: 'error',
  SET_INITIAL_DATA: 'set-data',

  TEXT_CHANGE: 'text-change',
  TEXT_SET_ERRORS: 'text-set-errors',
  TEXT_REMOVE_ERRORS: 'text-remove-errors',

  DATE_CHANGE: 'date-change',
  DATE_SET_ERRORS: 'date-set-errors',
  DATE_REMOVE_ERRORS: 'date-remove-errors',

  RADIO_CHANGE: 'radio-change',
  RADIO_SET_ERRORS: 'radio-set-errors',
  RADIO_REMOVE_ERRORS: 'radio-remove-errors',

  SELECT_CHANGE: 'select-change',
  SELECT_SET_ERRORS: 'select-set-errors',
  SELECT_REMOVE_ERRORS: 'select-remove-errors',

  CHECK_CHANGE: 'check-change',
  CHECK_SET_ERRORS: 'check-set-errors',
  CHECK_REMOVE_ERRORS: 'check-remove-errors',
};

const formInfoReducer = (state, action) => {
  // //console.log("dispatch triggered", state, action);

  switch (action.type) {
    case ACTIONS.SET_INITIAL_DATA: {
      return {
        ...state,
        data: action.data,
        loading: action.loading,
        selectOrg: action.selectOrg
      };
    }

    // ----- TEXT -----
    case ACTIONS.TEXT_CHANGE: {
      const path = state.data[action.name];
      return {
        ...state,
        data: {
          ...state.data,
          [action.name]: {
            ...state.data[action.name],
            value: action.value,
            validation: {
              ...path.validation,
              isInvalid: false,
              errors: []
            }
          }
        }
      };
    }
    case ACTIONS.TEXT_SET_ERRORS: {
      const path = state.data[action.name];
      return {
        ...state,
        data: {
          ...state.data,
          [action.name]: {
            ...state.data[action.name],
            validation: {
              ...path.validation,
              isInvalid: action.errors != null ? true : false,
              errors: action.errors
            }
          }
        }
      };
    }
    case ACTIONS.TEXT_REMOVE_ERRORS: {
      const path = state.data[action.name];
      return {
        ...state,
        data: {
          ...state.data,
          [action.name]: {
            ...state.data[action.name],
            validation: {
              ...path.validation,
              isInvalid: false,
              errors: []
            }
          }
        }
      };
    }

    // ----- DATE -----
    case ACTIONS.DATE_CHANGE: {
      const path = state.data[action.name];
      return {
        ...state,
        data: {
          ...state.data,
          [action.name]: {
            ...state.data[action.name],
            value: action.value,
            validation: {
              ...path.validation,
              isInvalid: false,
              errors: []
            }
          }
        }
      };
    }
    case ACTIONS.DATE_SET_ERRORS: {
      const path = state.data[action.name];
      return {
        ...state,
        data: {
          ...state.data,
          [action.name]: {
            ...state.data[action.name],
            validation: {
              ...path.validation,
              isInvalid: action.errors != null ? true : false,
              errors: action.errors
            }
          }
        }
      };
    }
    case ACTIONS.DATE_REMOVE_ERRORS: {
      const path = state.data[action.name];
      return {
        ...state,
        data: {
          ...state.data,
          [action.name]: {
            ...state.data[action.name],
            validation: {
              ...path.validation,
              isInvalid: false,
              errors: []
            }
          }
        }
      };
    }

    // ----- RADIO (reportType) -----
    case ACTIONS.RADIO_CHANGE: {
      const path = state.data[action.name];
      return {
        ...state,
        data: {
          ...state.data,
          [action.name]: {
            ...path,
            value: action.value,
            radioButtons: path.radioButtons.map((button) => {
              button.isChecked = (button.value == action.value);
              return button;
            }),
            validation: {
              ...path.validation,
              isInvalid: false,
              errors: []
            }
          }
        }
      };
    }
    case ACTIONS.RADIO_SET_ERRORS: {
      const path = state.data[action.name];
      return {
        ...state,
        data: {
          ...state.data,
          [action.name]: {
            ...path,
            validation: {
              ...path.validation,
              isInvalid: action.errors != null ? true : false,
              errors: action.errors
            }
          }
        }
      };
    }
    case ACTIONS.RADIO_REMOVE_ERRORS: {
      const path = state.data[action.name];
      return {
        ...state,
        data: {
          ...state.data,
          [action.name]: {
            ...path,
            validation: {
              ...path.validation,
              isInvalid: false,
              errors: []
            }
          }
        }
      };
    }

    // ----- SELECT (organization) -----
    case ACTIONS.SELECT_CHANGE: {
      const path = state.data[action.name];
      return {
        ...state,
        data: {
          ...state.data,
          [action.name]: {
            ...path,
            value: action.value,
            options: path.options.map((option) => {
              option.isSelected = (String(option.value) == String(action.value));
              return option;
            }),
            validation: {
              ...path.validation,
              isInvalid: false,
              errors: []
            }
          }
        }
      };
    }
    case ACTIONS.SELECT_SET_ERRORS: {
      const path = state.data[action.name];
      return {
        ...state,
        data: {
          ...state.data,
          [action.name]: {
            ...path,
            validation: {
              ...path.validation,
              isInvalid: action.errors != null ? true : false,
              errors: action.errors
            }
          }
        }
      };
    }
    case ACTIONS.SELECT_REMOVE_ERRORS: {
      const path = state.data[action.name];
      return {
        ...state,
        data: {
          ...state.data,
          [action.name]: {
            ...path,
            validation: {
              ...path.validation,
              isInvalid: false,
              errors: []
            }
          }
        }
      };
    }

    // ----- CHECKBOX (cfSettings, submissionTypes) -----
    case ACTIONS.CHECK_CHANGE: {
      // expects: action.fieldName (group), action.optionValue, action.checked
      const key = action.name ?? action.fieldName;   // support both
      const group = state.data[key];
      const updated = group.checkBoxes.map((option) => {
        const match =
          (option.value != null && String(option.value) === String(action.optionValue ?? action.value)) ||
          (option.id != null && String(option.id) === String(action.optionValue ?? action.value));
        if (match) option.isChecked = action.checked ?? !option.isChecked;
        return option;
      });
      const selectedValues = updated.filter(o => o.isChecked).map(o => o.value);
      return {
        ...state,
        data: {
          ...state.data,
          [action.fieldName]: {
            ...group,
            checkBoxes: group.checkBoxes.map((option) => {
              // match by value (string compare) or id
              const match =
                (option.value != null && String(option.value) == String(action.optionValue)) ||
                (option.id != null && String(option.id) == String(action.optionValue));
              if (match) {
                option.isChecked = action.checked;
                // keep option.value as-is; for submissionTypes it's 'Y'/'N', for cfSettings it's the id
              }
              return option;
            }),
            checkboxes: updated,
            value: selectedValues,
            validation: {
              ...group.validation,
              isInvalid: false,
              errors: []
            }
          }
        }
      };
    }
    case ACTIONS.CHECK_SET_ERRORS: {
      const group = state.data[action.fieldName];
      return {
        ...state,
        data: {
          ...state.data,
          [action.fieldName]: {
            ...group,
            validation: {
              ...group.validation,
              isInvalid: action.errors != null && action.errors.length > 0 ? true : false,
              errors: action.errors
            }
          }
        }
      };
    }
    case ACTIONS.CHECK_REMOVE_ERRORS: {
      const group = state.data[action.fieldName];
      return {
        ...state,
        data: {
          ...state.data,
          [action.fieldName]: {
            ...group,
            validation: {
              ...group.validation,
              isInvalid: false,
              errors: []
            }
          }
        }
      };
    }

    // ----- API submission flags -----
    case ACTIONS.CALL_API: {
      return { ...state, loading: true, apiError: null };
    }
    case ACTIONS.SUCCESS: {
      return { ...state, loading: false, apiError: null, apiResponse: action.response };
    }
    case ACTIONS.ERROR: {
      return { ...state, loading: false, apiError: action.error };
    }
  }
};

export { ACTIONS, formInfoReducer };
